
import { defineComponent, PropType, reactive, ref } from 'vue'

import BaseTree from '../group-tree/base-tree.vue'
import { Group } from '@/views/dashboard/_type/group'
import { groupTreeAllSystemTypes } from '@/views/dashboard/_enum/terminal-type'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale';
import { computed } from 'vue';

export default defineComponent({
  components: {
    BaseTree
  },
  props: {
    terminalType: {
      type: Array as PropType<number[]>,
      default: () => [...groupTreeAllSystemTypes],
    },
    width: {
      type: Number,
      default: IS_JP_ONLY_BUILD ? 310 : 290
    },
    referenceWidth: {
      type: [Number, String],
      default: 150
    },
    subnet_address: {
      type: String,
      default: ''
    },
    /** 默认选中的分组id，传null时选择第一个可选分组 */
    defaultGroupId: {
      type: [Number, null],
      default: -1
    },
    disabledIds: {
      type: Array as PropType<number[]>,
      default: () => ([])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterEmptyGroup: {
      type: Boolean,
      default: false,
    },
    /** 按钮元素的额外 class，用于兼容旧代码（如 cm-ui-mr10 等样式类） */
    class: {
      type: String,
      default: ''
    }
  },
  emits: ['selected'],
  setup (props, context) {
    const visible = ref(false)
    const groups = reactive<Group[]>([])
    const selectedGroup = reactive<Partial<Group>>({
      name: '',
      total: 0
    })

    function updateSelectedGroup (group: Group) {
      Object.assign(selectedGroup, group)
      context.emit('selected', group.group_id)
      visible.value = false
    }
     const style = computed(() => ({
      width: `${getWidth(props.referenceWidth)}`,
    }))

    function getWidth (value) {
      const tryNumber = +value
      if (typeof tryNumber === 'number' && tryNumber > 1 ) {
        return `${value}px`
      }
      return value
    }
    return {
      style,
      IS_JP_ONLY_BUILD,
      visible,
      groups,
      selectedGroup,
      customClass: props.class,
      clickNode (node: Group) {
        updateSelectedGroup(node)
      }
    }
  }
})
